var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownHandIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#DownHandIcon_svg__clip0_25_3839)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.336 8.641a.74.74 0 00.172.535.666.666 0 00.222.168c.084.04.175.06.267.06h1.267a.646.646 0 00.47-.206.723.723 0 00.194-.496V2.035a.723.723 0 00-.194-.496.646.646 0 00-.47-.206h-.718a.644.644 0 00-.45.185.717.717 0 00-.212.456l-.548 6.667zm4.583.28c0 .293.173.556.424.68.547.274 1.479.822 1.9 1.564.541.955.644 2.682.66 3.077.003.056.001.111.008.166.09.685 1.341-.115 1.82-.961.261-.46.294-1.062.267-1.534-.03-.504-.17-.99-.306-1.474L10.4 9.41h3.603a.634.634 0 00.295-.074.672.672 0 00.234-.204.722.722 0 00.11-.615L12.86 1.844a.704.704 0 00-.239-.369.64.64 0 00-.4-.142H6.582a.646.646 0 00-.47.206.723.723 0 00-.194.496v6.886z",
    fill: "#DE5B5B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "DownHandIcon_svg__clip0_25_3839"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "matrix(1 0 0 -1 1.333 14.667)",
    d: "M0 0h13.333v13.333H0z"
  })))));
}
export default SvgDownHandIcon;